export const DOCUMENT_TYPES = {
  AMLF_OFFICER_REQ_DOCS: "AmlOfficerRequestedDocument",
  EMPLOYEE_UPLOADED_DOC: "employeeUploadedDocument",
  POWER_OF_ATORNEY: "PowerOfAttorney",
  APP: "Application",
  ORGANIZATIONAL_CHART: "OrganizationalChart",
  ARTICLES_OF_ASSOCIATION: "ArticlesOfAssociation",
  WOLFSBERG_QUESTIONNAIRE: "WolfsbergQuestionnaire",
  BENEFICIARY_IDENTIFICATION: "BeneficiaryIdentification",
  AGREEMENTS: "Agreements",
  ONDATAOL_ID_DOC: "OndataoldentificationDocument",
  SAIS_REPORT: "SaisReport"
};

export const DOCUMENT_FLAG_OPTIONS = {
  FILE_WITH_MANDATORY_COMMENT: "FileWithMandatoryComment",
  FILE_WITHOUT_COMMENT: "FileWithoutComment",
  FILE_WITH_OPTIONAL_COMMENT: "FileWithOptionalComment",
  OPTIONAL_FILE_MANDATORY_COMMENT: "OptionalFileMandatoryComment",
  MANDATORY_COMMENT: "MandatoryComment"
};

export const FILE_REQUIRED = [
  DOCUMENT_FLAG_OPTIONS.FILE_WITHOUT_COMMENT,
  DOCUMENT_FLAG_OPTIONS.FILE_WITH_MANDATORY_COMMENT,
  DOCUMENT_FLAG_OPTIONS.FILE_WITH_OPTIONAL_COMMENT
];

export const COMMENT_REQUIRED = [
  DOCUMENT_FLAG_OPTIONS.FILE_WITH_MANDATORY_COMMENT,
  DOCUMENT_FLAG_OPTIONS.OPTIONAL_FILE_MANDATORY_COMMENT,
  DOCUMENT_FLAG_OPTIONS.MANDATORY_COMMENT
];
